<template>
  <div>
    <v-stepper v-model="currentStep">
      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step="1">
          Select Plan
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="currentStep > 2" step="2">
          Make Payment
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <PricingCard
            :pricingPlans="pricingPlans"
            :priceCategories="priceCategories"
            :selectedDocObj="selectedDocObj"
            @plan-selected="getSelectedPlan"
          ></PricingCard>
        </v-stepper-content>

        <v-stepper-content step="2">
          <div v-if="selectedPlan">
            <v-row class="px-4">
              <!-- <v-col :cols="isMobile ? 12 : 4">
                <CouponForm
                  class="mb-6"
                  :company="getUserCompany"
                  :selectedPlan="selectedPlan"
                >
                  <template #title>
                    <vAlertHeader
                      title="Unlock with Coupon Code"
                      color="teal"
                    ></vAlertHeader>
                  </template> </CouponForm
              ></v-col> -->

              <v-col :cols="isMobile ? 12 : 6">
                <PayfastPayment
                  class="mb-6"
                  :company="getUserCompany"
                  returnUrl="https://docs-ai.co.za/payment-complete"
                  cancelUrl="https://docs-ai.co.za/cancel-onboarding"
                  :selectedPlan="selectedPlan"
                  :mPaymentID="getUserIP"
                  :customStr="customStr"
                >
                  <template #title>
                    <vAlertHeader
                      title="OR Pay with PayFast"
                      color="red"
                    ></vAlertHeader>
                  </template> </PayfastPayment
              ></v-col>
              <v-col :cols="isMobile ? 12 : 6">
                <PayPalPayment
                  class="mb-6"
                  :company="getUserCompany"
                  :selectedPlan="selectedPlan"
                ></PayPalPayment
              ></v-col>
            </v-row>
          </div>

          <v-btn text @click="currentStep = 1"> Back </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import PricingCard from "./PricingCard";
import vAlertHeader from "@/components/Legos/vAlertHeader";
import PayfastPayment from "@/modules/OnboardNewClients/PayfastPayment.vue";
import PayPalPayment from "@/modules/OnboardNewClients/PayPalPayment.vue";
import CouponForm from "@/modules/OnboardNewClients/CouponForm.vue";
export default {
  components: {
    vAlertHeader,
    PricingCard,
    PayfastPayment,
    PayPalPayment,
    CouponForm,
  },
  computed: {
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getUserIP() {
      return this.$store.getters.getUserIP;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  props: {
    selectedDocObj: {
      default: () => ({}),
    },
    pricingPlans: {
      default: () => ({}),
    },
    priceCategories: {
      default: () => ({}),
    },
  },
  data: () => ({
    currentStep: 1,
    selectedPlan: null,
    customStr: null,
  }),
  methods: {
    getSelectedPlan(plan) {
      if (plan.title.includes("remium")) {
        this.customStr = "year";
      } else if (plan.title.includes("tandard")) {
        this.customStr = "monthly";
      } else if (plan.title.includes("asic")) {
        this.customStr = "single";
      } else {
        this.customStr = "guest";
      }
      this.selectedPlan = plan;
      this.currentStep = 2;
    },
  },
};
</script>
